//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentColumnMatchDisplayItem } from './StudentColumnMatchDisplayItem';
import { NameFormat } from './Enums';

export class StudentColumnMatchesDisplayItem extends ItemBase {
    Matches: StudentColumnMatchDisplayItem[] = [];
    HasHeader: boolean = false;
    StudentNameFormat: NameFormat | null = null;
    ParentNameFormat: NameFormat | null = null;

    constructor(initializer?: Partial<StudentColumnMatchesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentColumnMatchesDisplayItem";
}
